import { DependencyList, useCallback, useEffect, useRef } from 'react';
import { useSelector, useStore } from 'react-redux';

import { isElement, isHTMLElement } from '../../../util';
import { logChatbotClickLink, logWixContactClickOnALinkInsideASolution } from '../../bi';
import { selectConversationId } from '../../common/selectors/chat';
import { selectFieldNodeId } from '../../common/selectors/field';

type A = HTMLAnchorElement;

/**
 * We have to connect the link for current node ID and conversation ID
 * and don't update anymore
 */
// TODO - check if we can remove it. It causes unnecessary re-renders
const freez = () => false;

export const usePingLinkRef = <T extends HTMLElement>(deps: DependencyList = []) => {
  const store = useStore();
  const ref = useRef<T>(null);
  const conversation_id = useSelector(selectConversationId, freez);
  const node_id = useSelector(selectFieldNodeId, freez);

  const handleClick = useCallback(
    ({ target }: MouseEvent) => {
      if (!isElement(target)) {
        return;
      }

      const a: A | null = target.closest('a');

      if (isHTMLElement(a)) {
        const state = store.getState();
        const params = {
          isCta: false,
          link: a.href,
          label: a.textContent,
        };

        logChatbotClickLink(state, params);
        logWixContactClickOnALinkInsideASolution(state, params);
      }
    },
    [store, conversation_id, node_id],
  );

  useEffect(() => {
    const node = ref.current;

    if (isHTMLElement(node)) {
      const links = node.querySelectorAll<A>('a');

      links.forEach((a) => {
        Object.assign<A, Partial<A>>(a, { rel: 'noopener', target: '_blank' });
        a.addEventListener('click', handleClick);
      });

      return () => {
        links.forEach((a) => {
          a.removeEventListener('click', handleClick);
        });
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
};
